<template>
  <BaseLayout>
    <div class="card card-fullscreen">
      <div class="card-body">
        <LoadingBlock :loading="loadingSettings">
          <div class="row gy-sm-1">
            <div class="col-md-3 mt-2">
              <label class="form-label">Поиск по товарам</label>
              <input type="text" class="form-control border-1 py-2" placeholder="Название, код товара, бренд"
                     v-model="searchData.name" @change="search">
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Поиск по бренду</label>
              <input type="text" class="form-control border-1 py-2" placeholder="Название бренда"
                     v-model="searchData.brand" @change="search">
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Магазин</label>
              <Select v-model="activeStore" :options="stores" optionLabel="name" optionValue="id"
                      @change="setActiveStore"
                      placeholder="Магазин не выбран"
                      style="width: 100%">
              </Select>
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Категория ВБ</label>
              <Select v-model="searchData.wb_subject_id" :options="wbSubjects" optionLabel="name" optionValue="code" filter
                      placeholder="Категория не выбрана"
                      style="width: 100%"
                      @change="search"
                      @click="loadWbSubjects"
              >
              </Select>
            </div>
            <div class="col-md-2 mt-2">
              <label class="form-label">Размер страницы</label><br>
              <Select v-model="searchData.size" :options="pageSizes" optionLabel="name" optionValue="value"
                      @change="search"
              >
              </Select>
            </div>
            <div class="col-md-3 mt-2">
              <label class="form-label">Массовые действия</label>
              <div>
                <button class="btn btn-outline-primary"
                        @click="checkAll()"
                >
                  Выбрать/снять все
                </button>
              </div>
              <div>
                <button class="btn btn-outline-primary mt-1"
                        @click="mergeCards()"
                        :disabled="wb_merge_loading">
                  Объединить
                </button>
              </div>
            </div>

          </div>
          <div v-if="!products.length && !loadingProducts" class="mt-7">
            Товары не найдены
          </div>
        </LoadingBlock>
      </div>
      <div class="card-body">
        <LoadingBlock :loading="loadingOffers || loadingProducts">
          <template v-for="(product, index) in products" :key="index">
            <div class="row product-row">
              <WbCardBase :product="product" :offer="offers[product.id]"
                          @check="checkFromOffer"
              />
            </div>
          </template>

          <BasePagination :info="paginationInfo" ref="productsPagination" @changePage="changePage">
          </BasePagination>
        </LoadingBlock>
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from '@/layouts/Base.vue'
import {PageInfo} from "@/data/page";
import {user} from "@/data/user";
import {stores} from "@/data/store";
import {getProducts} from "@/api/product";
import BasePagination from "@/components/list/Pagination.vue"

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

import {getOffers, getWbSubjects, wb_merge} from "@/api/offer";
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import {Select} from "primevue";
import WbCardBase from "@/components/match/WbCard.vue";
import {afterStoreAction} from "@/helpers/store";

export default {
  name: 'WbCardsView',
  // eslint-disable-next-line vue/no-unused-components
  components: {
    WbCardBase,
    LoadingBlock, BaseLayout, BasePagination, Select
  },
  emits: ['batch-action'],
  data() {
    return {
      stores: [],
      wbSubjects: [],
      checked_all: false,
      wb_merge_loading: false,
      loadingSettings: true,
      loadingOffers: false,
      loadingProducts: true,
      activeStore: [],
      activeMarketplace: '',
      products: [],
      offers: {},
      paginationInfo: {},
      searchData: {
        name: '',
        brand: '',
        has_not_sent_offer_in_store: true,
        in_stock: true,
        size: '20',
      },
      productAttribute: null,
      batchAction: null,
      batchDisabled: [],
      pageSizes: [{name: '10', value: '10'}, {name: '20', value: '20'}, {name: '50', value: '50'}, {
        name: '100',
        value: '100'
      }]
    }
  },
  methods: {
    async getProducts() {
      this.products = []
      this.batchDisabled = []
      this.loadingProducts = true
      const result = await getProducts(user.active_company, this.$route.query, this.activeStore)
      this.paginationInfo = {
        total: result.data.total,
        pages: result.data.pages,
        page: result.data.page,
        size: result.data.size
      }
      this.products = result.data.items
      this.loadingProducts = false
    },
    async search() {
      const query = {...this.$route.query}
      delete query.page
      Object.entries(this.searchData).forEach(([key, value]) => {
        if (value) {
          query[key] = value
        } else {
          delete query[key]
        }
      });
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...query
        }
      })
    },
    setSearch() {
      if (this.$route.query.name) {
        this.searchData.name = this.$route.query.name
      } else {
        this.searchData.name = ''
      }
      if (this.$route.query.brand) {
        this.searchData.brand = this.$route.query.brand
      } else {
        this.searchData.brand = ''
      }
      if (this.$route.query.size) {
        this.searchData.size = this.$route.query.size
      } else {
        this.searchData.size = '20'
      }
      if (this.$route.query.in_stock) {
        this.searchData.in_stock = this.$route.query.in_stock
      } else {
        this.searchData.in_stock = NaN
      }
      if (this.$route.query.has_not_sent_offer_in_store) {
        this.searchData.has_not_sent_offer_in_store = this.$route.query.has_not_sent_offer_in_store
      } else {
        this.searchData.has_not_sent_offer_in_store = NaN
      }
    },
    async changePage(page) {
      await this.$router.push({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          page: page
        }
      });
    },
    setPageInfo() {
      PageInfo.title = 'Карточки'
      PageInfo.breadcrumbs = [
        {
          title: 'Главная',
          link: '/'
        },
        {
          title: PageInfo.title
        }
      ]
    },
    async setActiveStore() {
      await stores.setActiveStore(this.activeStore)
      const store = this.stores.filter((store) => store.id === this.activeStore)[0]
      this.activeMarketplace = store.marketplace
      await this.loadOffers()
    },
    async loadOffers(products = null) {
      this.offers = []
      if (!products) {
        products = this.products.map((product) => product.id)
      }
      if (!products.length || !this.activeStore) {
        return
      }

      this.loadingOffers = true
      const company_id = await user.getActiveCompany()
      const offers = await getOffers(company_id, this.activeStore, products)
      this.offers = []
      offers.data.forEach((offer) => this.offers[offer.product_id] = offer)
      this.loadingOffers = false
    },
    updateProductAttribute(attribute) {
      this.productAttribute = attribute;
    },
    async updateOffersList() {
      await this.loadOffers()
    },
    checkAll() {
      if (this.checked_all) {
        Object.values(this.offers).forEach((offer) => offer.checked = false)
      } else {
        Object.values(this.offers).forEach((offer) => this.checkOffer(offer))
      }
      this.checked_all = !this.checked_all
    },
    checkFromOffer(product_id, checked) {
      this.offers[product_id].checked = checked
    },
    checkOffer(offer) {
      if (offer['store_info'] && offer['store_info']['imt_id']) {
        offer.checked = true
      }
    },
    async mergeCards() {
      this.wb_merge_loading = true
      const checked_offers = Object.values(this.offers).filter((offer) => offer.checked)
      console.log(checked_offers.length)
      if (!checked_offers || checked_offers.length < 2) {
        alert('Выберите 2 или более товаров')
        this.wb_merge_loading = false
        return
      }
      if (checked_offers.length > 30) {
        alert('Можно выбрать не более 30 товаров')
        this.wb_merge_loading = false
        return
      }
      const subject_id = checked_offers[0]['store_info']['subject_id']
      checked_offers.forEach((offer) => {
        if (offer['store_info']['subject_id'] !== subject_id) {
          alert('У товаров разные категории')
          this.wb_merge_loading = false
          return
        }
      })
      const data_offers = checked_offers.map(item => item.id)
      const company_id = await user.getActiveCompany()
      const res = await wb_merge(company_id, checked_offers[0]['store_id'], data_offers)
      afterStoreAction(res)
      this.wb_merge_loading = false
    },
    async loadWbSubjects() {
      const data = this.searchData
      data.company = await user.getActiveCompany()
      const res = await getWbSubjects(this.activeStore, data)
      this.wbSubjects = Object.entries(res['data']).map(([code, name]) => ({
        code: code,
        name: name
      }));
    }
  },
  async mounted() {
    this.setPageInfo()
    this.setSearch()
    await user.getUserBase()
    this.stores = await stores.getStores()
    this.activeStore = await stores.getActiveStore()
    this.loadingSettings = false
    await this.getProducts()
    await this.setActiveStore()
  },
  watch: {
    async '$route'() {
      this.setSearch()
      this.setPageInfo()
      await this.getProducts()
      await this.setActiveStore()
    }
  }
}
</script>

<style>
.product-row {
  margin: 10px 0;
  border: 2px #eee solid;
  padding: 5px;
  border-radius: 2px;
}
</style>
